(() => {
  document.querySelectorAll('[data-rr-cost-form]').forEach(form => {
    const result = form.querySelector('[data-cost-result]');
    const currency = new Intl.NumberFormat('en-NZ', {style:'currency', currency:'NZD', maximumFractionDigits:2});
    const calculate = event => {
      if (event) event.preventDefault();
      const values = {};
      let missing = false;
      let invalid = false;
      form.querySelectorAll('[data-cost]').forEach(input => {
        const key = input.dataset.cost;
        const raw = input.value.trim();
        if (input.required && raw === '') missing = true;
        const number = raw === '' ? 0 : Number(raw);
        if (!Number.isFinite(number) || number < 0 || (input.required && number <= 0)) invalid = true;
        values[key] = number;
      });
      if (missing) { result.textContent = result.dataset.empty; return; }
      if (invalid || values.hours > 24 || values.days > 7) { result.textContent = result.dataset.invalid; return; }
      const electricity = values.watts / 1000 * values.hours * values.days * 52 * values.rate;
      const annual = electricity + values.blades + values.service;
      if (!Number.isFinite(annual) || annual > 1000000000) { result.textContent = result.dataset.invalid; return; }
      result.replaceChildren();
      for (const [label, amount] of [[result.dataset.month, electricity / 12], [result.dataset.year, annual]]) {
        const description = document.createElement('span');
        description.textContent = label;
        const value = document.createElement('strong');
        value.textContent = currency.format(amount);
        result.append(description, value);
      }
    };
    form.addEventListener('submit', calculate);
    form.addEventListener('input', calculate);
  });
})();
